import React, { useCallback, useState } from 'react';

import { Http } from '../../../../support';
import { useDropzone } from 'react-dropzone';
import ProcessCfdiToJsonInputConversion from '../../transformers/ProcessCfdiToJsonInputConversion';

function CfdiToJsonUploadForm({ comprobante, onChange }) {
  const [busy, setBusy] = useState(false)

  const onDrop = useCallback(async (acceptedFiles) => {
    setBusy(true);

    const formData = new FormData()

    formData.append('file', acceptedFiles[0]);
    formData.append('facturotopia', 1);

    try {
      const response = await Http.post(`/api/tools/cfdi2json`, formData);

      if (!response.data.Complemento?.TimbreFiscalDigital?.UUID) {
        throw new Error('El xml proporcionado no tiene timbre fiscal digital.');
      }

      const data = ProcessCfdiToJsonInputConversion.make(response.data, comprobante);

      setBusy(false);

      onChange(data);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No fue posible leer tu factura. =('
      });

      setBusy(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop,
    accept: 'application/xml, text/xml, text/plain'
  });

  return (
    <>
      { !busy && (
        <div { ...getRootProps({
          className: `dropzone
            ${isDragAccept && 'dropzone-accept'}
            ${isDragReject && 'dropzone-reject'}`
          }) }>

          <input { ...getInputProps() } />

          {
            isDragActive ?
              <p>Suelta tu xml aquí ...</p> :
              <p>Arrastra un xml a esta área o haz click para seleccionar.</p>
          }
        </div>
      )}

      { !!busy && (
       <div className="dropzone dropzone-busy">
         <div className="dot-flashing"></div>
       </div>
      )}
    </>
  )
}

export default CfdiToJsonUploadForm;